import { Box } from "@mui/material";
import React from "react";
import classess from "./Style.module.css";

const Possessivartikel1 = () => {
  const Title = ["ضمیر فاعلی", "مذکر / خنثی (der/das)", "مونث / جمع (die)"];
  const ST1 = ["ICH", "main", "maine"];
  const ST2 = ["DU", "dein", "deine"];
  const ST3 = ["ER", "sein", "seine"];
  const ST4 = ["SIE او", "ihr", "ihre"];
  const ST5 = ["ES", "sein", "seine"];
  const ST6 = ["WIR", "unser", "unsere"];
  const ST7 = ["IHR شما - غیر رسمی", "euer", "eure"];
  const ST8 = ["SIE آنها", "ihr", "ihre"];
  const ST9 = ["Sie شما - محترمانه", "Ihr", "Ihre"];
  return (
    <Box className={classess.Wrapper}>
      <span>۱. ضمایر ملکی پایه (در حالت اسمی - Nominativ)</span>
      <Box className={classess.WP}>
        {Title.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "110px",
                backgroundColor: "rgba(150, 150, 150, 0.1)",
                fontSize: "0.9rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST1.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "110px",
                fontSize: index === 2 ? "0.8rem" : "1.2rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST2.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "110px",
                fontSize: index === 2 ? "0.8rem" : "1.2rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST3.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "110px",
                fontSize: index === 2 ? "0.8rem" : "1.2rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST4.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "110px",
                fontSize: index === 2 ? "0.8rem" : "1.2rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST5.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "110px",
                fontSize: index === 2 ? "0.8rem" : "1.2rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST6.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "110px",
                fontSize: index === 2 ? "0.8rem" : "1.2rem",
                cursor: index === 2 ? null : "pointer",
              }}
            >
              {index === 2 ? (
                opt
              ) : (
                <abbr title={index === 1 ? "ONZA" : "ONZEGHE"}>{opt}</abbr>
              )}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST7.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "110px",
                fontSize: index === 2 ? "0.8rem" : "1.2rem",
                cursor: index === 2 ? null : "pointer",
              }}
            >
              {index === 2 ? (
                opt
              ) : (
                <abbr title={index === 1 ? "AIA" : "AIGHE"}>{opt}</abbr>
              )}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST8.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "110px",
                fontSize: index === 2 ? "0.8rem" : "1.2rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST9.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: "110px",
                fontSize: index === 2 ? "0.8rem" : "1.2rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <span>
        حالت Nominativ : این حالت برای فاعل جمله استفاده می‌شه، یعنی کسی یا چیزی
        که فعل رو انجام می‌ده.
      </span>
      <Box className={classess.Possessivartikel1}>
        نکات: اگر اسم مذکر یا خنثی باشد، ضمیر ملکی بدون تغییر می‌آید. اگر اسم
        مونث یا جمع باشد، یک "-e" به انتهای ضمیر ملکی اضافه می‌شود.
      </Box>
      <Box className={classess.Footers}>
        <span>
          Nominativ: „{" "}
          <label className={classess.Label}>Das ist mein Hund.</label>“
        </span>
        <span className={classess.Span}>(این سگِ من است)</span>
        <span style={{ marginTop: "8px" }}>
          Nominativ : „{" "}
          <label className={classess.Label}>Das ist meine Katze.</label>“
        </span>
        <span className={classess.Span}>(این گربه‌ی من است.)</span>
        <span style={{ marginTop: "8px" }}>
          Nominativ : „{" "}
          <label className={classess.Label}>Das sind meine Bücher.</label>“
        </span>
        <span className={classess.Span}>(این‌ها کتاب‌های من هستند.)</span>
        <span style={{ marginTop: "8px" }}>
          Nominativ : „{" "}
          <label className={classess.Label}>Das sind mein Auto.</label>“
        </span>
        <span className={classess.Span}>(این‌ ماشین من است.)</span>
      </Box>
    </Box>
  );
};

export default Possessivartikel1;
